import { Component, Inject, ViewChild } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { MultiSelectComponent } from '@progress/kendo-angular-dropdowns';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { UIActiveDialogService } from '../../../../shared/services/ui-dialog.service';
import { SortUtils } from '../../../../shared/utils/sort.utils';
import { AuthService } from '../../../security/service/auth.service';
import { UserModel } from '../../../user/model/user.model';
import { IssueUIMessages } from '../../model/issue-ui.messages';
import { IssueModel } from '../../model/issue.model';
import { IssueService } from '../../service/issue.service';

@Component({
  selector: 'customer-dialog',
  templateUrl:
    './console/app-js/modules/issue/components/customer-dialog/customer-dialog.component.html'
})
export class CustomerDialogComponent extends APIOperableComponent {
  protected user: UserModel;
  @ViewChild('kendoMultiSelectInstance', { static: true })
  protected kendoMultiSelectInstance: MultiSelectComponent;
  protected allCustomers: Array<any> = [];
  protected selectedCustomer: Array<any> = [];
  protected issueModel: IssueModel = new IssueModel();
  protected originalCustomers: Array<any> = [];
  protected originalAllCustomers: Array<any> = [];
  protected customers: Array<any> = [];

  constructor(
    @Inject('user') user: any,
    progressService: NgProgress,
    toastr: ToastrService,
    authService: AuthService,
    private activeDialog: UIActiveDialogService,
    private issueService: IssueService
  ) {
    super(progressService, toastr, authService);
    this.issueModel = user[0];
    if (user[0].keywords === 'Not Set') {
      this.issueModel.keywords = [];
    }
    this.originalCustomers = user[0].customerNumbers;
    this.originalCustomers.forEach((custNo, index) => {
      let customer = {
        id: user[0].id + index,
        number: custNo,
        name: user[0].name
      };
      this.customers.push(customer);
    });
    this.selectedCustomer = this.customers;
    this.loadAllCustomers();
  }

  /**
   * On Save button click.
   */
  onSave(): void {
    this.startProgress();
    this.issueService.updateIssue(this.issueModel).subscribe(
      result => {
        if (result.responseCode === 200) {
          this.finishProgress();
          this.onAPISuccess(IssueUIMessages.UPDATE_ISSUE_SUCCESS);
          this.activeDialog.close(true);
        } else {
          this.onAPIError(result.errorMessage);
        }
      },
      () => {
        this.activeDialog.close(this.issueModel);
        this.onAPIError(IssueUIMessages.UPDATE_ISSUE_ERROR);
      }
    );
  }

  /**
   * On Cancel/Close button event.
   */
  onCancelClose(): void {
    this.selectedCustomer = this.customers;
    this.issueModel.customerNumbers = this.originalCustomers;
    this.activeDialog.dismiss();
  }

  /**
   * Loads a list of customer
   *
   */
  private loadAllCustomers(): void {
    this.loadingIndicator = true;
    this.issueService.getCustomer().subscribe(
      (res: any) => {
        if (res.responseCode === 200) {
          let results = res.results.map((cust, index) => {
            return {
              id: index,
              number: cust.number,
              name: cust.name
            };
          });

          this.originalAllCustomers = results;

          // Map selected customers to allcustomers to update ID
          this.selectedCustomer.forEach(selectedCust => {
            results.forEach(cust => {
              if (selectedCust.number === cust.number) {
                cust.id = selectedCust.id;
              }
            });
          });

          this.loadingIndicator = false;
          this.allCustomers = results.sort((a, b) =>
            SortUtils.compareByProperty(a, b, 'number')
          );
        } else {
          this.onAPIError(IssueUIMessages.LOAD_CUSTOMER_LIST_ERROR);
        }
      },
      () => this.onAPIError(IssueUIMessages.LOAD_CUSTOMER_LIST_ERROR)
    );
  }

  /**
   * Filter customer from multiselect dropdown
   *
   */
  onFilterChange(filter: string) {
    if (filter.length > 0) {
      this.allCustomers = this.originalAllCustomers.filter(
        item =>
          item.name.toLowerCase().includes(filter.toLowerCase()) ||
          item.number.toLowerCase().includes(filter.toLowerCase())
      );
    } else {
      this.allCustomers = this.originalAllCustomers;
      this.kendoMultiSelectInstance.toggle(false);
    }
  }

  /**
   * check special characters
   *
   */
  protected checkSpecialChar(e): any {
    if (
      (e.which < 48 && e.which !== 45) ||
      (e.which > 57 && e.which < 65) ||
      (e.which > 90 && e.which < 97) ||
      e.which > 122
    ) {
      e.preventDefault();
    }
  }

  /**
   * Filter group list.
   * @param $event
   */
  onValueChange(customers) {
    let customerNumbers = [];
    if (customers && customers.length > 0) {
      customers.forEach(cust => {
        customerNumbers.push(cust.number);
      });
    }
    this.issueModel.customerNumbers = customerNumbers;
    this.selectedCustomer = customers;
  }
}
